import {
  Card,
  CardContent,
  CardHeader,
} from "@/components/ui/v2/card";
import { Skeleton } from "@/components/ui/v2/skeleton";

function CampaignJobBoardCardSkeleton() {
  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <Skeleton className="h-6 w-32" />
          <Skeleton className="h-6 w-16 rounded-full" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-2">
          <Skeleton className="size-4 rounded" />
          <Skeleton className="h-4 w-52" />
        </div>
        <div className="mt-4 space-y-2">
          <div className="flex items-baseline justify-between">
            <Skeleton className="h-6 w-16" />
            <Skeleton className="h-4 w-40" />
          </div>
          <Skeleton className="h-2 w-full rounded-full" />
          <Skeleton className="h-3 w-48" />
        </div>
      </CardContent>
    </Card>
  );
}

export default CampaignJobBoardCardSkeleton;
